if (!window.seventeencoProductDetailsReady) {
  window.seventeencoProductDetailsReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-size-guide]');
    if (trigger) document.getElementById(trigger.dataset.productSizeGuide)?.showModal();
    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.product-size-chart-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
}
